var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZoomInIcon = function SvgZoomInIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9a1 1 0 0 1 1-1h2V6a1 1 0 1 1 2 0v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H6a1 1 0 0 1-1-1Z",
    fill: "#455A64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.215 16.336a9 9 0 1 1 2.121-2.121l.02.02 4.394 4.394a1.5 1.5 0 1 1-2.121 2.121l-4.395-4.394-.02-.02ZM16.2 9A7.2 7.2 0 1 1 1.8 9a7.2 7.2 0 0 1 14.4 0Z",
    fill: "#455A64"
  })));
};
export default SvgZoomInIcon;